<template>
  <div class="products pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n</v-btn
          >
          <b>افزودن محصول جدید</b>
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">لیست تنوعات </h4>
        <v-divider
          class="me-10 ms-10 d-none d-sm-none d-md-block"
          vertical
        ></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
            class="mt-5 mt-sm-5 mt-md-0"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#6200ea'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row class="flex-sm-row flex-column">
            <v-col>
              <div class="d-flex flex-row">
                <h4 class="primary--text">انبارداری فروشگاه</h4>
                <span style="padding-top: 2px" class="c-grey ms-4"
                  >({{ Number(products.length).toLocaleString() }} تنوع)</span
                >
              </div>
             
            </v-col>
            <v-col>
                <div class="pb-3">
                     <v-switch
                style="vertical-align: start !important"
                class="pt-0"
                v-model="barcodeFiltering"
                label="نمایش محصولات بدون بارکد"
                @change="barcodeFilter"
              >
              </v-switch>
                </div>
            </v-col>
          </v-row>

          <hr />
          <vue-excel-xlsx
            v-if="computedItems.length"
            :data="computedItems"
            style="float: left"
            class="darkGreen-mainBtn white--text py-2 px-6 mx-2 mb-6"
            :columns="excelFields"
            :filename="'انبارداری فروشگاه '"
            sheetname="انبارداری فروشگاه"
          >
            <v-icon class="white--text">mdi-file-excel</v-icon> دریافت اکسل
          </vue-excel-xlsx>
          <div class="custom-table mt-3">
            
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="productsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(name)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell(sum)="data">
                <div style="text-align: center; vertical-align: middle">
                  <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                    اتمام موجودی
                  </div>
                  <div v-else>{{ data.value }}</div>
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    min-width: 100px;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(barcode)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    min-width: 100px;
                  "
                >
                  {{ data.value ? data.value : "--" }}
                </div>
              </template>
              <template v-slot:cell(size)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
               <template v-slot:cell(dimension)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
               <template v-slot:cell(weight)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
               <template v-slot:cell(volume)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
 <template v-slot:cell(producingCountry)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
               <template v-slot:cell(productionYear)="data">
  <div class="text-center">
    {{ data.value ? data.value : "-" }}
  </div>
</template>
               <template v-slot:cell(contents)="data">
  <div v-if="data.value.length > 10">
    <v-tooltip top>
      <template v-slot:activator="{ on, attr }">
        <span v-on="on" v-bind="attr"> {{ data.value.slice(0, 10) }} </span
        ><span>...</span>
      </template>
      <div>
        <span>
          {{ data.value }}
        </span>
      </div>
    </v-tooltip>
  </div>
  <div v-else>{{ data.value ? data.value : "-" }}</div>
</template>
      
 <template v-slot:cell(color)="data">
              <div>
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
 <template v-slot:cell(onlineName)="data">
              <div>
                {{ data.value ? data.value : "-" }}
              </div>
            </template>
            <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="orange-mainBtn"
                    width="100"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="100"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  v-show="roleName == 'sales'"
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    @click="editBarcode(row.item)"
                    class="orange-mainBtn"
                    width="120"
                    >ویرایش بارکد</v-btn
                  >
                </div>
                <div v-show="roleName != 'sales'"  style="text-align: center; vertical-align: middle"
                  class="pt-0">
                   <v-btn
                    class="purple white--text mx-2"
                    width="155"
                    height="40"
                       @click="editProduct(row.item)"
                    ><v-icon class="me-1">mdi-pencil-outline</v-icon
                    >ویرایش محصول</v-btn
                  >
                     <v-btn
                    class="green white--text mx-2"
                    width="155"
                    height="40"
                       @click="editModal(row.item, row.index)"
                    ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                    >ویرایش تنوع</v-btn
                  >
                  
                      
                        <v-btn
                        class="green-mainBtn me-2 ms-2 mt-2 mt-sm-0 "
                        width="155"
                        height="40"
                        @click="openDialog(row.item, 'increase')"
                        ><v-icon class="me-1">mdi-plus-box-outline</v-icon
                        >افزایش موجودی</v-btn
                      >
                      <v-btn
                        class="yellow-mainBtn me-2 ms-2 mt-2 mt-sm-0 "
                        width="155"
                        height="40"
                        @click="openDialog(row.item, 'decrease')"
                        :disabled="!Number(row.item.sum)"
                        ><v-icon class="me-1">mdi-minus-box-outline</v-icon>کاهش
                        موجودی</v-btn
                      >
                </div>
              </template>
              
            </b-table>
            <v-row class="mt-6">
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="perPage"
                    :items="perPageOptions"
                    @change="currentPage = 1"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-left text-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-sm-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <v-dialog v-model="editBarcodeDialog" width="400">
      <v-card>
       <v-card-title class="white"
          ><v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ویرایش بارکد
              </h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="editBarcodeDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-0 pt-0" />
        <v-card-text class="pb-0 pt-3">
          <v-text-field
            rounded
            dense
            outlined
            v-model="selectedItem.barcode"
            label="بارکد"
            class="mt-3"
          >
          </v-text-field>
        </v-card-text>
        <div class="text-left pe-3 pb-3">
          <v-btn
            class="me-3 green-mainBtn white--text"
            @click="doEditBarcode(selectedItem.barcode)"
          >
            ثبت
          </v-btn>
          <v-btn
            @click="editBarcodeDialog = false"
            class="red-mainBtn white--text"
          >
            لغو
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
        <v-dialog v-model="openEditDialog" width="800">
      <v-card>
        <v-card-title class="white"
          ><v-row>
            <v-col>
              <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                ویرایش تنوع
              </h4>
            </v-col>

            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="openEditDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>

        <hr class="mt-0 pt-0" />
        <v-card-text class="pa-3">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">بارکد:</label>
              <v-text-field
                placeholder="بارکد"
                outlined
                dense
                v-model="selectedVariety.barcode"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <label class="primary--text font-weight-bold"
                >تاریخ اعتبار:</label
              >
              <span id="expireDateEdit">
                <v-text-field
                  placeholder="تاریخ اعتبار"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedVariety.expireDate"
                ></v-text-field>
              </span>
              <date-picker
                element="expireDateEdit"
                v-model="selectedVariety.expireDate"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت خرید (تومان):</label
              >
              <v-text-field
                placeholder="قیمت خرید (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariety.buyPrice"
              ></v-text-field>
              <span v-show="selectedVariety.buyPrice" class="ps-2 pt-4"
                >{{
                  Number(selectedVariety.buyPrice / 10).toLocaleString()
                }}
                تومان</span
              >
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> قیمت فروش (تومان):</label
              >
              <v-text-field
                placeholder="قیمت فروش (تومان)"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedVariety.price"
              ></v-text-field>
              <span v-if="selectedVariety.price" class="ps-2 pt-4">
                {{ Number(selectedVariety.price / 10).toLocaleString() }}
                تومان</span
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">سال تولید:</label>
              <v-text-field
                placeholder="سال تولید"
                outlined
                dense
                v-model="selectedVariety.productionYear"
                hide-details
                type="number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                کشور تولید کننده:
              </label>
              <v-text-field
                placeholder="کشور تولید کننده"
                outlined
                dense
                v-model="selectedVariety.producingCountry"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">رنگ:</label>
              <v-text-field
                placeholder="رنگ"
                outlined
                dense
                v-model="selectedVariety.color"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">کد رنگ:</label>
              <div class="color-box">
                <v-text-field
                  v-model="selectedVariety.colorCode"
                  hide-details
                  outlined
                  dense
                  @click="editColorMenu = true"
                ></v-text-field>
                <v-menu
                  offset-y
                  v-model="editColorMenu"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="color"
                      :style="'background-color:' + selectedVariety.colorCode"
                    ></div>
                  </template>
                  <div class="pa-0">
                    <v-color-picker
                      dot-size="15"
                      mode="hexa"
                      v-model="selectedVariety.colorCode"
                    ></v-color-picker>
                  </div>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> سایز: </label>
              <v-text-field
                placeholder="سایز"
                outlined
                dense
                v-model="selectedVariety.size"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">حجم:</label>
              <v-text-field
                placeholder="حجم"
                outlined
                dense
                v-model="selectedVariety.volume"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> ابعاد: </label>
              <v-text-field
                placeholder="ابعاد"
                outlined
                dense
                v-model="selectedVariety.dimension"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">وزن:</label>
              <v-text-field
                placeholder="وزن"
                outlined
                dense
                v-model="selectedVariety.weight"
                hide-details
              
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                ترکیبات و محتویات:
              </label>
              <v-text-field
                placeholder="ترکیبات و محتویات"
                outlined
                dense
                v-model="selectedVariety.contents"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="text-left pe-3 pb-4 mt-4">
            <v-btn class="green-mainBtn me-3" @click="editVariant()" :disabled="editDisable">
              تایید
            </v-btn>
            <v-btn class="red-mainBtn" @click="openEditDialog = false">
              بستن
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
       <v-dialog v-model="increaseDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-0 pe-sm-4">
              <h4 class="c-grey mb-0">ورود کالا - افزایش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-0 pe-sm-4">
              <span class="pointer" @click="increaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ ورود:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedItem.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedItem.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت ورود:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت ورود"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedItem.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedItem.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم ورودی:</label>
              <v-text-field
                placeholder="حجم ورودی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مبدا:</label>
              <v-text-field
                placeholder="مبدا"
                outlined
                dense
                hide-details
                v-model="selectedItem.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <label class="primary--text font-weight-bold pt-2">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedItem.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="increaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="entrySubmit()"
            :disabled="busy || computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="decreaseDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col class="pe-sm-4 pe-0 ps-sm-4 ps-0">
              <h4 class="c-grey mb-0">خروج کالا - کاهش موجودی</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2 pe-sm-4 ps-sm-4 ps-0 pe-0">
              <span class="pointer" @click="decreaseDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"> تاریخ خروج:</label>
              <span id="date1">
                <v-text-field
                  placeholder="تاریخ خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-calendar"
                  v-model="selectedItem.date"
                ></v-text-field>
              </span>
              <date-picker
                element="date1"
                v-model="selectedItem.date"
                type="date"
                color="#6200ea"
              ></date-picker>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold">ساعت خروج:</label>
              <span id="time1">
                <v-text-field
                  placeholder="ساعت خروج"
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-clock-outline"
                  v-model="selectedItem.time"
                ></v-text-field>
              </span>
              <date-picker
                element="time1"
                v-model="selectedItem.time"
                type="time"
                color="#6200ea"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold"> حجم خروجی:</label>
              <v-text-field
                placeholder="حجم خروجی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.number"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <label class="primary--text font-weight-bold">مقصد:</label>
              <v-text-field
                placeholder="مقصد"
                outlined
                dense
                hide-details
                v-model="selectedItem.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <label class="primary--text font-weight-bold pt-2">توضیحات:</label>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedItem.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="decreaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="exitSubmit()"
            :disabled="busy || computedSubmitBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      tab: null,
      moment: moment,
      openEditDialog: false,
      variants:[],
      selectedIndex:"",
       colorMenu: false,
      editColorMenu: false,
       selectedVariety: {},
      deviceType: "",
      allExchanges: [],
      filter: "",
      guide: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      products: [],
      allProducts: [],
      selectedSort: "کمترین موجودی",
      selectedItem: {},
      newItem: {
        price: 0,
        buyPrice: 0,
      },
      loading: false,
      loading2: false,
      loading3: false,
      expireProducts: [],
      busy: false,
      editDialog: false,
      increaseDialog: false,
      decreaseDialog: false,
      newProductDialog: false,
      calendarType: "startDate",
      startDate: "",
      endDate: "",
      barcodeFiltering: false,

      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "onlineName", label: "نام فروشگاهی" },
        { key: "price", label: "قیمت " },
        { key: "sum", label: "موجودی " },
        { key: "color", label: "رنگ " },
        { key: "size", label: " سایز" },
        { key: "volume", label: "حجم" },
        { key: "dimension", label: "ابعاد " },
        { key: "weight", label: " وزن" },
        { key: "producingCountry", label: "محصول کشور " },
        { key: "productionYear", label: "سال تولید " },
        // { key: "contents", label: "ترکیبات " },

        { key: "barcode", label: "بارکد" },

        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "name", label: "نام محصول" },
        { field: "price", label: "قیمت" },
        { field: "sum", label: "موجودی" },
 { field: "color", label: "رنگ " },
        { field: "size", label: " سایز" },
        { field: "volume", label: "حجم" },
        { field: "dimension", label: "ابعاد " },
        { field: "weight", label: " وزن" },
        { field: "producingCountry", label: "محصول کشور " },
        { field: "productionYear", label: "سال تولید " },
        // { field: "contents", label: "ترکیبات " },
        { field: "barcode", label: "بارکد" },
      ],

      productsLoading: false,

      editBarcodeDialog: false,
      role: "",
      roleName: "",
      increaseDialog:false,
    decreaseDialog :false,

    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    editProduct(item){
  let link = "/shop/editproduct/" + item.parentItem;
    window.open(link,"_blank");
    },
     entrySubmit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/entrance" ,
        {
          warehouseItemId: this.selectedItem.id,
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.increaseDialog = false;
            this.getProducts();
            // this.submit();
            this.busy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
         
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/exit/",
        {
          warehouseItemId: this.selectedItem.id,
          // warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.decreaseDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openDialog(item, type) {
    
       if (type == "increase") {
        this.selectedItem = JSON.parse(JSON.stringify(item));
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.increaseDialog = true;
      } else if (type == "decrease") {
        this.selectedItem = JSON.parse(JSON.stringify(item));
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.decreaseDialog = true;
      }
    },
     editVariant() {
        Axios.patch(
          this.baseUrl +
            "/satrapp/warehouse/warehouseItem/editVariant/" +
            this.selectedVariety.id,
          {
            color: this.selectedVariety.color,
            colorCode: this.selectedVariety.colorCode,
            size: this.selectedVariety.size,
            volume: this.selectedVariety.volume,
            dimension: this.selectedVariety.dimension,
            weight: this.selectedVariety.weight,
            producingCountry: this.selectedVariety.producingCountry,
            productionYear: this.selectedVariety.productionYear,
            contents: this.selectedVariety.contents,
            expireDate: this.selectedVariety.expireDate,
            price: Number(this.selectedVariety.price),
            buyPrice: Number(this.selectedVariety.buyPrice),
            sum: Number(this.selectedVariety.sum)
              ? Number(this.selectedVariety.sum)
              : 0,
            barcode: this.selectedVariety.barcode,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast(res.data.message, "success");
              this.variants[this.selectedIndex] = this.selectedVariety;
              this.openEditDialog= false;
              this.selectedVariety = {};
              this.selectedIndex = "";
              this.getProducts();
            } else {
              const title = (
                <div>
                  <h5>خطا </h5>
                  <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                </div>
              );
              this.toast(title, "error");
            }
          })
          .catch((err) => {
            this.toast("خطا: " + err.response.data, "error");
            this.variants[this.selectedIndex] = this.selectedVariety;
            this.openEditDialog = false;
            this.selectedVariety = {};
            this.selectedIndex = "";
          });
      
    },
    
    editModal(item, index) {
      this.selectedVariety = JSON.parse(JSON.stringify(item));
      this.selectedVariety.colorCode = item.colorCode
        ? item.colorCode
        : "#bf0000";
      this.selectedIndex = index;
      this.openEditDialog = true;
    },
    openNewProduct() {
      this.newProductDialog = true;
      this.guide = false;
    },
    barcodeFilter() {
      if (this.barcodeFiltering) {
        let noBarcodeFiltered;
        noBarcodeFiltered = this.products.filter((x) => x.barcode == "");
        this.products = noBarcodeFiltered;
      } else {
        this.products = this.allProducts;
      }
    },
    editBarcode(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.editBarcodeDialog = true;
    },
    doEditBarcode() {
      this.busy = true;
      Axios.patch(
        this.baseUrl +
          "/satrapp/warehouse/warehouseItem/editBarcode/" +
          this.selectedItem.id,
        { barcode: this.selectedItem.barcode },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.getProducts();
            // this.submit();
            this.busy = false;
            this.editBarcodeDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
            this.editBarcodeDialog = false;
          }
        })
        .catch((err) => {
      
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
          this.editBarcodeDialog = false;
        });
    },
    getProducts() {
      this.loading = true;
      Axios.get(
        this.baseUrl + "/satrapp/warehouse/warehouseItems/getAllWithVariants",
      
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.allProducts = res.data;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openDialog(item, type) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      if (type == "edit") {
        this.editDialog = true;
      } else if (type == "increase") {
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.increaseDialog = true;
      } else if (type == "decrease") {
        this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.selectedItem.time = moment(new Date()).format("HH:mm");
        this.decreaseDialog = true;
      }
    },
    submit() {
      this.loading2 = true;
      let startDate = this.startDate + " 00:00";
      let finishDate = this.endDate + " 23:59";
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouse/exchanges",
        {
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading2 = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading2 = false;
        });
    },
    addItem() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/goods/new",
        {
          warehouseTypeId: this.type.id,
          name: this.newItem.name,
          amount: this.newItem.amount,
          identifierFa: this.newItem.name,
          identifierEn: this.newItem.name,
          description: this.newItem.description,
          technicalDescription: this.newItem.technicalDescription,
          material: this.newItem.material,
          coating: this.newItem.coating,
          dimensionStandard: this.newItem.dimensionStandard,
          diameter: this.newItem.diameter,
          length: this.newItem.length,
          place: this.newItem.place,
          suppliersList: this.newItem.suppliersList,
          expireDate: this.newItem.expireDate,
          measurementUnit: this.newItem.measurementUnit,
          alertRange: this.newItem.alertRange,
          crisisRange: this.newItem.crisisRange,
          price: this.newItem.price,
          buyPrice: this.newItem.buyPrice,
          barcode: this.newItem.barcode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.getProducts();
            this.newProductDialog = false;
            this.newItem = {};
            this.busy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editItem() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selectedItem.id,
          name: this.selectedItem.name,
          identifierFa: this.selectedItem.name,
          identifierEn: this.selectedItem.name,
          description: this.selectedItem.description,
          technicalDescription: this.selectedItem.technicalDescription,
          material: this.selectedItem.material,
          coating: this.selectedItem.coating,
          dimensionStandard: this.selectedItem.dimensionStandard,
          diameter: this.selectedItem.diameter,
          length: this.selectedItem.length,
          place: this.selectedItem.place,
          suppliersList: this.selectedItem.suppliersList,
          expireDate: this.selectedItem.expireDate,
          measurementUnit: this.selectedItem.measurementUnit,
          alertRange: this.selectedItem.alertRange,
          crisisRange: this.selectedItem.crisisRange,
          price: this.selectedItem.price,
          buyPrice: this.selectedItem.buyPrice,
          barcode: this.selectedItem.barcode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.getProducts();
            this.busy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    entrySubmit() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/entrance",
        {
          warehouseItemId: this.selectedItem.id,
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.increaseDialog = false;
            this.getProducts();
            // this.submit();
            this.busy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
        
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/satrapp/warehouse/exchanges/exit",
        {
          warehouseItemId: this.selectedItem.id,
          // warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.decreaseDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  computed: {
 computedItems() {
      let filtered;
      filtered = this.products.filter(
        (x) =>
          x.name.toLowerCase().includes(this.filter.toLowerCase()) ||
          x.onlineName.toLowerCase().includes(this.filter.toLowerCase()) ||
          x.productionYear.includes(this.filter) ||
          x.producingCountry.includes(this.filter) ||
          x.color.includes(this.filter) ||
          x.size.includes(this.filter) ||
          x.dimension.includes(this.filter) ||
          x.volume.includes(this.filter) ||
          x.weight.includes(this.filter) ||
          String(x.barcode).includes(this.filter) ||
          String(x.price).includes(this.filter) ||
          String(x.sum).includes(this.filter)
      );
      return filtered;
    },
      computedSubmitBtn() {
      if (
        this.selectedItem.date &&
        this.selectedItem.time &&
        this.selectedItem.number &&
        this.selectedItem.origin
      ) {
        return false;
      } else return true;
    },

    editDisable(){
 if(this.selectedVariety.price && this.selectedVariety.buyPrice )
      {
        return false;
      }
      else return true;
    },
    
  computedEditBtn() {
    if (
      this.selectedItem.name &&
      this.selectedItem.price &&
      this.selectedItem.buyPrice
    ) {
      return false;
    } else return true;
  },
  },
 
  mounted() {
    if (window.screen.width < 768) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }
    this.getProducts();
    this.roleName = window.localStorage.getItem("role");

    this.endDate = moment(new Date()).format("jYYYY/jMM/jDD");
    this.startDate = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
  },
};
</script>

<style lang="scss">
.products {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    @media only screen and (max-width: 768px) {
      padding: 11px 15px;
    }
    color: #656a81;
    width: fit-content;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
  .custom-input {
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #4ba0e7 !important;
        cursor: pointer;
      }
    }
    .date-input {
      fieldset {
        border: 1px solid #4ba0e7 !important;
      }
    }
    .date-input.v-input--is-disabled {
      fieldset {
        border-color: rgba(118, 118, 118, 0.3) !important;
      }
    }
  }
}
.v-tabs:not(.v-tabs--vertical).v-tabs--right
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__next,
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  display: none !important;
  visibility: hidden;
}

.product-dialog-card {
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #6200ea !important;
        cursor: pointer;
      }
    }
  }
}
.table th, .table td {
    padding: 0.5rem !important;
   

}
.color-box {
  direction: ltr;
  display: flex;
  border: none !important;
  .color {
    width: 40px;
    height: 40px;
    // margin-top: 8px;
  }
}
</style>
